import React from 'react';

const MaintenanceIllustration = ({ children }) => {
  return <>{children}</>;
};

export default MaintenanceIllustration;

// illustrations

// Landing
MaintenanceIllustration.Desktop = () => (
  <svg
    width="400"
    height="170"
    viewBox="0 0 400 170"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M117.916 137.676C130.076 130.474 158.269 118.875 173.759 130.099C193.122 144.13 199.576 155.355 216.414 153.391C233.251 151.426 234.654 131.222 228.48 125.609C221.742 119.484 214.449 127.854 218.939 134.589C223.429 141.324 236.618 134.589 236.618 121.681C236.618 108.663 229.041 105.685 226.797 79.5878C224.579 53.8111 251.491 20.377 292.742 23.4638C333.993 26.5506 356.443 55.1738 353.356 83.2358"
      stroke="#B1BDC9"
      strokeWidth="4.48547"
    />
    <rect
      x="0.85498"
      y="34.543"
      width="159.012"
      height="110.731"
      rx="5.27703"
      transform="rotate(-11.6778 0.85498 34.543)"
      fill="#728199"
    />
    <rect
      x="81.8594"
      y="115.332"
      width="43.033"
      height="38.8346"
      transform="rotate(-11.6778 81.8594 115.332)"
      fill="#728199"
    />
    <rect
      x="89.2944"
      y="151.307"
      width="60.351"
      height="5.77271"
      rx="0.791554"
      transform="rotate(-11.6779 89.2944 151.307)"
      fill="#B1BDC9"
    />
    <rect
      x="5.99414"
      y="33.4805"
      width="159.012"
      height="110.731"
      rx="5.27703"
      transform="rotate(-11.6778 5.99414 33.4805)"
      fill="#B1BDC9"
    />
    <mask
      id="mask0_18132_31481"
      maskUnits="userSpaceOnUse"
      x="6"
      y="2"
      width="178"
      height="139"
    >
      <rect
        x="5.99561"
        y="33.4805"
        width="159.012"
        height="110.731"
        rx="5.27703"
        transform="rotate(-11.6778 5.99561 33.4805)"
        fill="#C4C4C4"
      />
    </mask>
    <g mask="url(#mask0_18132_31481)">
      <rect
        x="-7.86035"
        y="23.4834"
        width="184.727"
        height="107.058"
        transform="rotate(-11.6778 -7.86035 23.4834)"
        fill="#171717"
      />
    </g>
    <rect
      x="15.916"
      y="40.0039"
      width="142.219"
      height="78.194"
      rx="1.31926"
      transform="rotate(-11.6778 15.916 40.0039)"
      fill="#E2E8F0"
    />
    <circle cx="93.3059" cy="63.3069" r="29.0764" fill="#A1B6CA" />
    <circle cx="93.1054" cy="63.1068" r="23.2611" fill="#E8EEF4" />
    <rect
      x="93.0513"
      y="45.8613"
      width="7.21897"
      height="22.058"
      rx="1.31926"
      transform="rotate(20.0601 93.0513 45.8613)"
      fill="#133053"
    />
    <rect
      x="87.4907"
      y="63.2939"
      width="7.21897"
      height="15.3233"
      rx="1.31926"
      transform="rotate(-28.0647 87.4907 63.2939)"
      fill="#A1B6CA"
    />
    <path
      d="M110.312 68.2335C111.506 63.722 110.829 59.1537 108.758 55.3454C107.214 52.5067 104.895 50.0902 102 48.4342M83.0277 78.1001C80.6167 76.4061 78.6915 74.1502 77.3929 71.573C76.3069 69.4177 75.6592 67.0377 75.532 64.574"
      stroke="white"
      strokeWidth="2.63851"
      strokeLinecap="round"
    />
    <rect
      x="273.899"
      y="55.8428"
      width="126.562"
      height="58.7902"
      rx="1.31926"
      transform="rotate(12.7486 273.899 55.8428)"
      fill="#728199"
    />
    <rect
      x="275.702"
      y="47.8779"
      width="126.562"
      height="58.7902"
      rx="1.31926"
      transform="rotate(12.7486 275.702 47.8779)"
      fill="#B1BDC9"
    />
    <rect
      x="295.049"
      y="86.1885"
      width="71.8547"
      height="15.5141"
      rx="1.31926"
      transform="rotate(12.7486 295.049 86.1885)"
      fill="#E2E8F0"
    />
    <rect
      width="15.5141"
      height="15.5141"
      rx="1.31926"
      transform="matrix(0.975348 0.220674 -0.220673 0.975348 276.731 82.0449)"
      fill="#E2E8F0"
    />
    <rect
      width="15.5141"
      height="15.5141"
      rx="1.31926"
      transform="matrix(0.975348 0.220673 -0.220674 0.975348 281.776 59.7461)"
      fill="#E95B24"
    />
    <rect
      x="300.094"
      y="63.8896"
      width="15.514"
      height="15.514"
      rx="1.31926"
      transform="rotate(12.7486 300.094 63.8896)"
      fill="#E2E8F0"
    />
    <rect
      x="318.411"
      y="68.0342"
      width="15.5141"
      height="15.5141"
      rx="1.31926"
      transform="rotate(12.7486 318.411 68.0342)"
      fill="#E2E8F0"
    />
    <rect
      width="15.514"
      height="15.514"
      rx="1.31926"
      transform="matrix(0.975347 0.220674 -0.220672 0.975348 336.729 72.1777)"
      fill="#E2E8F0"
    />
    <rect
      width="15.5141"
      height="15.5141"
      rx="1.31926"
      transform="matrix(0.975348 0.220672 -0.220674 0.975348 355.045 76.3223)"
      fill="#E2E8F0"
    />
    <rect
      width="15.5141"
      height="15.5141"
      rx="1.31926"
      transform="matrix(0.975348 0.220673 -0.220674 0.975348 373.364 80.4668)"
      fill="#E2E8F0"
    />
    <rect
      x="368.318"
      y="102.767"
      width="15.514"
      height="15.514"
      rx="1.31926"
      transform="rotate(12.7486 368.318 102.767)"
      fill="#E2E8F0"
    />
  </svg>
);
